export default class Mode{

    static SUPPORT_QUERY=1;
    static SUPPORT_EXPORT=2;
    static SUPPORT_EXPORT_DETAIL=4;
    static SUPPORT_ADD_LOW_LEVEL=8;
    static SUPPORT_ADD_SAME_LEVEL=16;
    static SUPPORT_STOP=32;
    static SUPPORT_RESTORE=64;
    static SUPPORT_CREATE=128;
    static SUPPORT_EDIT=256;
    static SUPPORT_DELETE=512;
    static SUPPORT_SAVE=1024;
    static SUPPORT_AUDIT=2048;
    static SUPPORT_CANCEL_AUDIT=4096;
    static SUPPORT_VOID=8192;
    static SUPPORT_CANCEL_VOID=16384;
    static SUPPORT_PUT_ON=32768;
    static SUPPORT_WITHDRAW=65536;
    static SUPPORT_BROWSE_DETAIL=131072;
    static SUPPORT_REFRESH=262144;

    //自定义
    static SUPPORT_CUSTOM_1=524288;
    static SUPPORT_CUSTOM_2=1048576;
    static SUPPORT_CUSTOM_3=2097152;
    static SUPPORT_CUSTOM_4=4194304;
    static SUPPORT_CUSTOM_5=8388608;
    static SUPPORT_CUSTOM_6=16777216;

    static ifSupportQuery(mode){
        return (mode & Mode.SUPPORT_QUERY)>0;
    }

    static ifSupportExport(mode){
        return (mode & Mode.SUPPORT_EXPORT)>0;
    }

    static ifSupportExportDetail(mode){
        return (mode & Mode.SUPPORT_EXPORT_DETAIL)>0;
    }

    static ifSupportAddLowerLevel(mode){
        return (mode & Mode.SUPPORT_ADD_LOWER_LEVEL)>0;
    }

    static ifSupportAddSameLevel(mode){
        return (mode & Mode.SUPPORT_ADD_SAME_LEVEL)>0;
    }

    static ifSupportStop(mode){
        return (mode & Mode.SUPPORT_STOP)>0;
    }

    static ifSupportRestore(mode){
        return (mode & Mode.SUPPORT_RESTORE)>0;
    }


    static ifSupportCreate(mode){
        return (mode & Mode.SUPPORT_CREATE)>0;
    }

    static ifSupportEdit(mode){
        return (mode & Mode.SUPPORT_EDIT)>0;
    }

    static ifSupportDelete(mode){
        return (mode & Mode.SUPPORT_DELETE)>0;
    }

    static ifSupportSave(mode){
        return (mode & Mode.SUPPORT_SAVE)>0;
    }

    static ifSupportAudit(mode){
        return (mode & Mode.SUPPORT_AUDIT)>0;
    }

    static ifSupportCancelAudit(mode){
        return (mode & Mode.SUPPORT_CANCEL_AUDIT)>0;
    }

    static ifSupportVoid(mode){
        return (mode & Mode.SUPPORT_VOID)>0;
    }

    static ifSupportCanceVoid(mode){
        return (mode & Mode.SUPPORT_CANCEL_VOID)>0;
    }

    static ifSupportPutOn(mode){
        return (mode & Mode.SUPPORT_PUT_ON)>0;
    }

    static ifSupportWithDraw(mode){
        return (mode & Mode.SUPPORT_WITHDRAW)>0;
    }

    static ifSupportBrowseDetail(mode){
        return (mode & Mode.SUPPORT_BROWSE_DETAIL)>0;
    }

    static ifSupportRefresh(mode){
        return (mode & Mode.SUPPORT_REFRESH)>0;
    }

    static ifSupportCustom1(mode){
        return (mode & Mode.SUPPORT_CUSTOM_1)>0;
    }

    static ifSupportCustom2(mode){
        return (mode & Mode.SUPPORT_CUSTOM_2)>0;
    }

    static ifSupportCustom3(mode){
        return (mode & Mode.SUPPORT_CUSTOM_3)>0;
    }

    static ifSupportCustom4(mode){
        return (mode & Mode.SUPPORT_CUSTOM_4)>0;
    }

    static ifSupportCustom5(mode){
        return (mode & Mode.SUPPORT_CUSTOM_5)>0;
    }

    static ifSupportCustom6(mode){
        return (mode & Mode.SUPPORT_CUSTOM_6)>0;
    }
    
}